import { useState, useEffect, useCallback } from "react";
import { getRecords } from "../../services/api.service";

const useFetchData = (initialPayload, page, pageSize, endpoint, searchfields) => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [totalCount, setTotalCount] = useState(0);

    const getData = useCallback(async () => {
        try {
            setIsLoading(true);
            let payload = {
                ...initialPayload,
            };

            if (searchKeyword) {
                payload.search = {
                    field_name: searchfields || [],
                    searchKeyword: searchKeyword,
                };
            } else {
                payload.pagination = {
                    page: page + 1,
                    pageSize: pageSize,
                }
            }
            
            const responseData = await getRecords(payload, endpoint);
            if (responseData.code === 1) {
                setTotalCount(responseData.count);
                const sortedData = responseData.data
                  .map((element, index) => ({
                    ...element,
                    index: index + 1, 
                    // index: page * pageSize + (index + 1), // if you want increment sr.no then use it
                  }))
                  .sort((a, b) => b.index - a.index);
                setData(sortedData);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    }, [page, pageSize, searchKeyword, initialPayload]);

    useEffect(() => {
        getData();
    }, [getData]);

    return {
        data,
        isLoading,
        setSearchKeyword,
        totalCount,
    };
};

export default useFetchData;